export default __webpack_public_path__ + "static/media/logo.647f1ed4.svg";